// extracted by mini-css-extract-plugin
export default {"rowHasBadge":"uj-z","carouselContainer":"vj-z","carouselContent":"wj-z"};